import React from 'react';
import { Spin } from 'antd';
import { useAtom, useAtomValue } from 'jotai';
import * as atoms from '../atom';
import { Loading } from '../../common/Loading';
import { Retry } from '../../common/Retry';
import { DataSourceSelector } from '../DataSourceSelector';
import { DimensionCategory } from '../DimensionCategory';
import { SavedFilterList } from '../SavedFilterList';
import { FilterPanel } from '../FilterPanel';
import { useResetState, useFilterPanelVisible } from '../hooks';
import * as Styled from './styled';

const Main = () => {
  const isFilterMetaLoading = useAtomValue(atoms.isFilterMetaLoading);
  const isFilterMetaError = useAtomValue(atoms.isFilterMetaError);
  const visible = useAtomValue(atoms.visible);
  const callbacks = useAtomValue(atoms.callbacks);
  const { isVisible: isFilterPanelVisible } = useFilterPanelVisible();
  const { reset } = useResetState();
  const [ asyncLoadingMask, setAsyncLoadingMask ] = useAtom(atoms.asyncLoadingMask);

  const handleOnClose = () => {
    setAsyncLoadingMask(false);
    reset();
    callbacks.onClose?.();
  };

  const renderContent = () => {

    if (isFilterMetaError) {
      return <Retry onClick={() => callbacks.onFilterMetaRetry?.()}/>
    }

    return (
      <Styled.ContentContainer>
        {
          !isFilterPanelVisible && <Styled.LeftPanel> <DimensionCategory /> </Styled.LeftPanel>
        }
        <Styled.RightPanel>
          <DataSourceSelector />
          <FilterPanel />
          {
            !isFilterPanelVisible && !isFilterMetaLoading && <SavedFilterList />
          }
        </Styled.RightPanel>
        { isFilterMetaLoading && <Loading /> }
      </Styled.ContentContainer>
    );
  }

  return (
    <Styled.Drawer
      open={visible}
      closeIcon={null}
      contentWrapperStyle={{
        width: '85%',
        minWidth: '800px',
      }}
      bodyStyle={{
        backgroundColor: '#f6f6f6',
        padding: 0
      }}
      onClose={handleOnClose}
    >
      { renderContent() }
      <Styled.CloseIcon onClick={handleOnClose} />
      { asyncLoadingMask ? <Styled.LoadingMask><Spin /></Styled.LoadingMask> : null }
    </Styled.Drawer>
  );
}

export default React.memo(Main);
